// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  DeviceServiceContent,
  unionToDeviceServiceContent,
  unionListToDeviceServiceContent,
} from "./device-service-content";
import {
  ElevatorServiceMessage,
  ElevatorServiceMessageT,
  verifyElevatorServiceMessage,
} from "./elevator-service-message";
import {
  EscalatorServiceMessage,
  EscalatorServiceMessageT,
  verifyEscalatorServiceMessage,
} from "./escalator-service-message";

export class ServiceMessage implements flatbuffers.IUnpackableObject<ServiceMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ServiceMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsServiceMessage(bb: flatbuffers.ByteBuffer, obj?: ServiceMessage): ServiceMessage {
    return (obj || new ServiceMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsServiceMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ServiceMessage,
  ): ServiceMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ServiceMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  messageType(): DeviceServiceContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceServiceContent.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startServiceMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: DeviceServiceContent) {
    builder.addFieldInt8(0, messageType, DeviceServiceContent.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endServiceMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createServiceMessage(
    builder: flatbuffers.Builder,
    messageType: DeviceServiceContent,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ServiceMessage.startServiceMessage(builder);
    ServiceMessage.addMessageType(builder, messageType);
    ServiceMessage.addMessage(builder, messageOffset);
    return ServiceMessage.endServiceMessage(builder);
  }

  unpack(): ServiceMessageT {
    return new ServiceMessageT(
      this.messageType(),
      (() => {
        const temp = unionToDeviceServiceContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ServiceMessageT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToDeviceServiceContent(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ServiceMessageT {
    const t = new ServiceMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToDeviceServiceContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ServiceMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: DeviceServiceContent = DeviceServiceContent.NONE,
    public message: ElevatorServiceMessageT | EscalatorServiceMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return ServiceMessage.createServiceMessage(builder, this.messageType, message);
  }

  clone(): ServiceMessageT {
    const obj = new ServiceMessageT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: ServiceMessageT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyServiceMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorServiceMessage
            {
              const o = verifier.readInt32(pos);
              verifyElevatorServiceMessage(verifier, pos + o);
            }
            break;
          case 2: // EscalatorServiceMessage
            {
              const o = verifier.readInt32(pos);
              verifyEscalatorServiceMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
